(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getSpeedSeconds(viewport) {
    var section = viewport.closest('.pdp-recognized-by');
    if (!section) return 30;
    var raw = getComputedStyle(section).getPropertyValue('--pdp-recognized-speed').trim();
    var value = parseFloat(raw);
    return value > 0 ? value : 30;
  }

  function disableLinks(group) {
    group.querySelectorAll('a').forEach(function (link) {
      link.setAttribute('tabindex', '-1');
    });
  }

  function whenImagesReady(container, callback) {
    var images = container.querySelectorAll('img');
    if (!images.length) {
      setTimeout(callback, 0);
      return;
    }

    var remaining = images.length;
    var called = false;

    function done() {
      remaining -= 1;
      if (remaining <= 0 && !called) {
        called = true;
        setTimeout(callback, 0);
      }
    }

    images.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        done();
      } else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });

    // Fallback timeout in case images don't fire load events
    setTimeout(function () {
      if (!called) {
        called = true;
        callback();
      }
    }, 2000);
  }

  function fillGroup(group, viewportWidth) {
    var originals = Array.from(group.querySelectorAll('.pdp-recognized-by__logo'));
    if (!originals.length) return;

    var guard = 0;
    while (group.scrollWidth < viewportWidth && guard < 24) {
      originals.forEach(function (logo) {
        group.appendChild(logo.cloneNode(true));
      });
      guard += 1;
    }
  }

  function stopMarquee(viewport) {
    if (viewport._pdpRecognizedRaf) {
      cancelAnimationFrame(viewport._pdpRecognizedRaf);
      viewport._pdpRecognizedRaf = null;
    }
  }

  function startMarquee(viewport, track, segmentWidth, direction) {
    stopMarquee(viewport);

    var speedSeconds = getSpeedSeconds(viewport);
    var speedPxPerSec = segmentWidth / speedSeconds;
    var offset = direction === 'left_to_right' ? -segmentWidth : 0;
    var lastTime = performance.now();
    var paused = false;

    function onEnter() {
      paused = true;
    }

    function onLeave() {
      paused = false;
      lastTime = performance.now();
    }

    if (viewport.classList.contains('pdp-recognized-by__viewport--pause-hover')) {
      viewport.addEventListener('mouseenter', onEnter);
      viewport.addEventListener('mouseleave', onLeave);
      viewport._pdpRecognizedPauseHandlers = { onEnter: onEnter, onLeave: onLeave };
    }

    function step(now) {
      if (!paused) {
        var dt = (now - lastTime) / 1000;
        lastTime = now;

        if (direction === 'right_to_left') {
          offset -= speedPxPerSec * dt;
          if (offset <= -segmentWidth) offset += segmentWidth;
        } else {
          offset += speedPxPerSec * dt;
          if (offset >= 0) offset -= segmentWidth;
        }
      } else {
        lastTime = now;
      }

      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      viewport._pdpRecognizedRaf = requestAnimationFrame(step);
    }

    viewport._pdpRecognizedRaf = requestAnimationFrame(step);
  }

  function buildTrack(viewport) {
    var track = viewport.querySelector('.pdp-recognized-by__track');
    if (!track) return;

    stopMarquee(viewport);

    if (viewport._pdpRecognizedPauseHandlers) {
      viewport.removeEventListener('mouseenter', viewport._pdpRecognizedPauseHandlers.onEnter);
      viewport.removeEventListener('mouseleave', viewport._pdpRecognizedPauseHandlers.onLeave);
      viewport._pdpRecognizedPauseHandlers = null;
    }

    var direction = track.classList.contains('pdp-recognized-by__track--left_to_right')
      ? 'left_to_right'
      : 'right_to_left';

    if (!viewport.dataset.pdpRecognizedSource) {
      var initialGroup = track.querySelector('.pdp-recognized-by__group');
      if (!initialGroup) return;
      viewport.dataset.pdpRecognizedSource = initialGroup.innerHTML;
    }

    var viewportWidth = viewport.getBoundingClientRect().width;
    if (!viewportWidth) return;

    track.innerHTML = '';
    track.style.transform = '';
    track.style.animation = 'none';

    var groupA = document.createElement('div');
    groupA.className = 'pdp-recognized-by__group';
    groupA.innerHTML = viewport.dataset.pdpRecognizedSource;

    track.appendChild(groupA);
    fillGroup(groupA, viewportWidth);

    var groupMarkup = groupA.innerHTML;
    groupA.innerHTML = groupMarkup;

    var groupB = document.createElement('div');
    groupB.className = 'pdp-recognized-by__group';
    groupB.setAttribute('aria-hidden', 'true');
    groupB.innerHTML = groupMarkup;
    disableLinks(groupB);

    track.appendChild(groupB);

    var buildId = (viewport._pdpRecognizedBuildId || 0) + 1;
    viewport._pdpRecognizedBuildId = buildId;

    whenImagesReady(track, function () {
      if (viewport._pdpRecognizedBuildId !== buildId) return;

      // Re-measure and fill after images load
      fillGroup(groupA, viewportWidth);
      groupMarkup = groupA.innerHTML;
      groupA.innerHTML = groupMarkup;
      groupB.innerHTML = groupMarkup;
      disableLinks(groupB);

      // Use scrollWidth for segment measurement
      var segmentWidth = groupA.scrollWidth;
      
      // Fallback: if scrollWidth is 0, use bounding rect
      if (!segmentWidth) {
        segmentWidth = groupA.getBoundingClientRect().width;
      }

      if (!segmentWidth || segmentWidth < 10) {
        console.warn('pdp-recognized: segment width too small', segmentWidth);
        return;
      }

      if (prefersReducedMotion()) {
        track.style.transform = '';
        return;
      }

      startMarquee(viewport, track, segmentWidth, direction);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pdp-recognized-marquee]').forEach(buildTrack);
  }

  var resizeTimer;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(initAll, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', onResize);
  window.addEventListener('load', function() {
    setTimeout(initAll, 100);
  });
})();
